module.exports = __webpack_public_path__ + "media/images/next-60551c0f540553800ef647f4b9713bac.svg";